/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ThirdPartySyncLinkType {
    Vera = 'Vera',
    Cheggnet = 'Cheggnet',
    Cca = 'Cca',
    IdAustria = 'IdAustria'
  }

    export const ThirdPartySyncLinkTypeTranslocoMap: Record<ThirdPartySyncLinkType, string> = {
    [ThirdPartySyncLinkType.Vera]: 'thirdPartySyncLinkType.vera',
    [ThirdPartySyncLinkType.Cheggnet]: 'thirdPartySyncLinkType.cheggnet',
    [ThirdPartySyncLinkType.Cca]: 'thirdPartySyncLinkType.cca',
    [ThirdPartySyncLinkType.IdAustria]: 'thirdPartySyncLinkType.idAustria',
    };

    export const ThirdPartySyncLinkTypeOptions = [
  { value: ThirdPartySyncLinkType.Vera, labelKey: 'thirdPartySyncLinkType.vera' },
  { value: ThirdPartySyncLinkType.Cheggnet, labelKey: 'thirdPartySyncLinkType.cheggnet' },
  { value: ThirdPartySyncLinkType.Cca, labelKey: 'thirdPartySyncLinkType.cca' },
  { value: ThirdPartySyncLinkType.IdAustria, labelKey: 'thirdPartySyncLinkType.idAustria' },
    ];

